import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../lib/cn";
import { BrandLogo } from "./brand-logo";
import { TermsLinksFooter } from "./terms-links-footer";
/**
 * The one frame for every screen a user sees OUTSIDE the app shell: the logo above the
 * content, the content (usually one `Card`), and the appearance controls below it. Each
 * auth page used to repeat its own `<main>` wrapper; this is that wrapper, once.
 *
 * Renders the page's `<main>` landmark, so extra attributes (`role="status"`,
 * `aria-busy`) pass straight through for a loading screen.
 */
export function AuthLayout({ brandName, controls, width = "narrow", termsLinks, className, children, ...props }) {
    return (_jsxs("main", { className: cn("bg-surface text-primary flex min-h-svh flex-col items-center gap-4 px-4 py-6", width === "narrow" ? "justify-center" : "justify-start sm:py-10", className), ...props, children: [_jsx(BrandLogo, { alt: brandName, size: "md", className: "mb-2" }), width === "narrow" ? children : _jsx("div", { className: "w-full", children: children }), termsLinks === undefined ? null : _jsx(TermsLinksFooter, { ...termsLinks }), controls === undefined ? null : (_jsx("div", { className: "flex flex-wrap items-center justify-center gap-2", children: controls }))] }));
}
AuthLayout.displayName = "AuthLayout";
//# sourceMappingURL=auth-layout.js.map